import {
  IncidentProduct,
  IncidentSeverity,
  IncidentStatus,
} from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createIncident = {
  name: "createIncident" as const,
  input: z.object({
    title: z.string().min(1),
    message: z.string().min(1),
    severity: createEnum(IncidentSeverity),
    status: createEnum(IncidentStatus),
    type: createEnum(IncidentProduct),
    isGlobal: z.boolean(),
    isTest: z.boolean(),
    teamIds: z.array(zExt.objectId()).optional(),
    notes: z.string().optional(),
    publicUrl: z.string().url().optional(),
  }),
  output: z.object({ incidentId: zExt.objectId() }),
};
